import { render } from "./confirmrefundreturn.vue?vue&type=template&id=1bbd068b"
import script from "./confirmrefundreturn.vue?vue&type=script&lang=js"
export * from "./confirmrefundreturn.vue?vue&type=script&lang=js"

import "./confirmrefundreturn.vue?vue&type=style&index=0&id=1bbd068b&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__